// extracted by mini-css-extract-plugin
module.exports = {"mmc-bold":"Header_mmc-bold__1xST2","mmc-regular":"Header_mmc-regular__36ICX","fira-code":"Header_fira-code__-SQQq"};